module.exports = __webpack_public_path__ + "static/media/41-5.a1831787.mp3";